import { ActionTypes } from 'utils/constants';
import { getDeepProp } from 'utils/get-deep-prop';

const initialState = {};

export const myLearning = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_MY_LEARNING + '_PENDING': {            
            return {
                ...state,
                fetching: true,
                error: null
            };
        }
        case ActionTypes.FETCH_MY_LEARNING + '_FULFILLED': {  
            const data = getDeepProp(action, 'payload', 'data') || {};
          
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: null,
                data
            };
        }
        case ActionTypes.FETCH_MY_LEARNING + '_REJECTED': {    
            const error = getDeepProp(action, 'payload', 'response', 'data', 'msg') || 'Unable to load My Learning';
        
            return {
                ...state,
                fetching: false,
                fetched: false,
                error
            };
        }
        case ActionTypes.LOGOUT:
        case ActionTypes.VALIDATE_JWT + '_REJECTED': {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
